import { render, staticRenderFns } from "./eDSApproval.vue?vue&type=template&id=278ecd27"
import script from "./eDSApproval.vue?vue&type=script&lang=js"
export * from "./eDSApproval.vue?vue&type=script&lang=js"
import style0 from "./eDSApproval.vue?vue&type=style&index=0&id=278ecd27&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports